import api from '../../../api/client';
// components/Receivables.js
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, ProgressBar, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Pie, Bar } from "react-chartjs-2";
import axios from "axios";
import { formatKES } from "../../../utils/currency";
import MainCard from "../../../components/Card/MainCard";

const Receivables = ({ dateRange, fetchData }) => {
  const [receivablesData, setReceivablesData] = useState([]);

  useEffect(() => {
    fetchData("receivables", setReceivablesData);
  }, [dateRange, fetchData]);
if (!receivablesData || receivablesData.length === 0) {
    return (
      <div className="text-center py-4">No receivables data available</div>
    );
  }

  const data = receivablesData;

  if (!data) return <p>Loading...</p>;

  // Table Columns
  const columns = [
    { name: "Category", selector: (row) => row.category, sortable: true },
    { name: "Customer", selector: (row) => row.customer_name, sortable: true },
    {
      name: "Total",
      selector: (row) => formatKES(row.total_amount),
      sortable: true,
    },
    {
      name: "Paid",
      selector: (row) => formatKES(row.paid_amount),
      sortable: true,
    },
    {
      name: "Balance",
      selector: (row) => formatKES(row.balance_amount),
      sortable: true,
    },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Due Date",
      selector: (row) => row.due_date || "-",
      sortable: true,
    },
    {
      name: "Days Overdue",
      selector: (row) => row.days_overdue || "-",
      sortable: true,
    },
  ];

  // Stakeholder Balance Table
  const stakeholderColumns = [
    { name: "Stakeholder", selector: (row) => row.name, sortable: true },
    {
      name: "Total Amount",
      selector: (row) => formatKES(row.total),
      sortable: true,
    },
    { name: "Paid", selector: (row) => formatKES(row.paid), sortable: true },
    {
      name: "Balance",
      selector: (row) => formatKES(row.balance),
      sortable: true,
    },
    {
      name: "Transactions",
      selector: (row) => row.transactions,
      sortable: true,
    },
  ];

  // Convert stakeholder breakdown to array for DataTable
  const stakeholderTableData = Object.entries(data.breakdown.byStakeholder).map(
    ([name, stats]) => ({
      name,
      ...stats,
    }),
  );

  return (
    <>
      <Row className="mt-4">
        <Col>
          <MainCard title="Receivables by Stakeholder" isOption>
            <DataTable
              columns={stakeholderColumns}
              data={stakeholderTableData}
              pagination
              highlightOnHover
              striped
              responsive
              bordered
              paginationPerPage={20}
              paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: "Rows per page:",
              }}
              paginationResetDefaultPage={true}
              paginationTotalRows={stakeholderTableData.length}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#279e6c", // Green background
                    color: "#fff", // White text
                    textTransform: "uppercase", // Uppercase text
                    // fontSize: '10px', // Adjust font size for header row
                    minHeight: "1.5rem",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                },
              }}
            />
          </MainCard>
        </Col>
      </Row>

      {/* Table */}
      <Row className="mt-4">
        <Col>
          <MainCard title="Receivables Details" isOption>
            <DataTable
              columns={columns}
              data={data.records}
              pagination
              highlightOnHover
              striped
              responsive
              bordered
              paginationPerPage={20}
              paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: "Rows per page:",
              }}
              paginationResetDefaultPage={true}
              paginationTotalRows={data.records?.length}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#279e6c", // Green background
                    color: "#fff", // White text
                    textTransform: "uppercase", // Uppercase text
                    // fontSize: '10px', // Adjust font size for header row
                    minHeight: "1.5rem",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                },
              }}
            />
          </MainCard>
        </Col>
      </Row>
    </>
  );
};

export default Receivables;
